export const iconFontAwesomeCommunicationAt = (
	<i className="fa-solid fa-at"></i>
);
